import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import OpenFacebookRow from './OpenFacebookRow';
import GoToInboxRow from './GoToInboxRow';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class VerifyFbmPrompt extends PureComponent {
  componentDidMount() {
    const {
      pageId,
      getFbmInstall
    } = this.props;
    getFbmInstall({
      pageId
    });
  }
  render() {
    const {
      closePrompt,
      pageName,
      pageLink
    } = this.props;
    if (!pageName) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Modal, {
      use: "conversational",
      width: 670,
      children: [/*#__PURE__*/_jsx(DialogHeader, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "MessagesApp.verifyFbmPrompt.header",
            options: {
              pageName
            }
          })
        })
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockEnd: "500",
          as: "div",
          children: /*#__PURE__*/_jsx(Illustration, {
            name: "successfully-submitted-question",
            width: 120
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "800",
          as: "p",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "MessagesApp.verifyFbmPrompt.subheader"
          })
        }), /*#__PURE__*/_jsxs(Text, {
          textAlign: "left",
          marginBlockEnd: "300",
          children: [/*#__PURE__*/_jsx(Illustration, {
            name: "beta",
            width: 40
          }), /*#__PURE__*/_jsx(Text, {
            as: "h5",
            display: "inline-block",
            marginInlineStart: "300",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "MessagesApp.verifyFbmPrompt.tableHeader"
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(OpenFacebookRow, {
            pageLink: pageLink
          }), /*#__PURE__*/_jsx(GoToInboxRow, {
            onConfirm: closePrompt
          })]
        }), /*#__PURE__*/_jsx(View, {
          marginBlockStart: "700",
          as: "div",
          children: /*#__PURE__*/_jsx(Button, {
            onClick: closePrompt,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "MessagesApp.verifyFbmPrompt.closeButton"
            })
          })
        })]
      })]
    });
  }
}
VerifyFbmPrompt.displayName = 'VerifyFbmPrompt';
export default VerifyFbmPrompt;